/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ wait: NonNullable<unknown> }} Feedback_WaitInputs */



/**
* | output |
* | --- |
* | "You can send more feedback in {wait}." |
*
* @param {Feedback_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_wait = /** @type {((inputs: Feedback_WaitInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_WaitInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Vous pourrez envoyer un autre commentaire dans ${i?.wait}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Podrá enviar otro comentario dentro de ${i?.wait}.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Poderá enviar mais feedback dentro de ${i?.wait}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Potrai inviare altro feedback tra ${i?.wait}.`)
	return /** @type {LocalizedString} */ (`You can send more feedback in ${i?.wait}.`)
});